/* Noah.Q v335: the native product form owns variant, quantity and cart state. */
(() => {
 'use strict';
 if (window.__noahqProduct335) return;
 window.__noahqProduct335 = true;
 const context = button => {
   const info = button.closest('product-info');
   const form = info?.querySelector('product-form form[data-type="add-to-cart-form"]');
   return {info,form,add:form?.querySelector('[type="submit"]')};
 };
 function sync() {
   document.querySelectorAll('[data-noahq-buy-now]').forEach(b => {
     const {add}=context(b);
     if(b.dataset.busy !== 'true') {const off=!add || add.disabled || add.getAttribute('aria-disabled')==='true';if(b.disabled !== off) b.disabled=off;}
   });
 }
 document.addEventListener('click', async event => {
   const button=event.target.closest('[data-noahq-buy-now]');
   if(!button) return;
   event.preventDefault();
   const {info,form,add}=context(button);
   if(!form || button.disabled || add?.disabled || add?.getAttribute('aria-disabled')==='true') return;
   if(!form.reportValidity()) return;
   const quantity=info.querySelector('input[name="quantity"]');
   if(quantity && !quantity.reportValidity()) return;
   button.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');
   const label=button.textContent;button.textContent='購入手続きへ移動中…';
   const payload=new FormData(form);
   if(quantity) payload.set('quantity',quantity.value);
   try {
     const response=await fetch(window.routes?.cart_add_url || '/cart/add.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});
     const data=await response.json();
     if(!response.ok || data.status) throw new Error(data.description || data.message || 'カートに追加できませんでした。');
     const root=window.Shopify?.routes?.root || '/';
     location.assign(root+'checkout');
   } catch(error) {
     // Never automatically repeat a possibly successful POST on a network failure.
     const message=error.message || '通信を確認し、カートの内容をご確認ください。';
     const pf=form.closest('product-form');
     if(pf?.handleErrorMessage) pf.handleErrorMessage(message);
     else {let output=info.querySelector('.noahq-purchase-error');if(!output){output=document.createElement('p');output.className='noahq-purchase-error';output.setAttribute('role','alert');button.after(output);}output.textContent=message;}
     button.textContent=label;button.dataset.busy='false';button.removeAttribute('aria-busy');sync();
   }
 });
 document.addEventListener('change',()=>setTimeout(sync,0));
 document.addEventListener('shopify:section:load',sync);
 const observe = () => {
   document.querySelectorAll('product-info').forEach(info=>new MutationObserver(sync).observe(info,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']}));
   sync();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe,{once:true});else observe();
})();
